import * as React from "react"
import { HorizontalSpacer, Spacer } from "../atoms/spacers"
import H3 from "../atoms/typography/H3"
import H4 from "../atoms/typography/H4"
import Checkbox from "../atoms/inputs/Checkbox"
import ToggleButton from "../atoms/inputs/ToggleButton"

interface Props {
  notificationsEnabled: boolean
  notifyViaEmail: boolean
  userEmail?: string
  onChangeNotificationsEnabled?: (notificationsEnabled: boolean) => void
  onChangeNotifyViaEmail?: (notifyViaEmail: boolean) => void
}

const NotificationSettingsSection: React.FunctionComponent<Props> = ({
  notificationsEnabled,
  notifyViaEmail,
  userEmail,
  onChangeNotificationsEnabled,
  onChangeNotifyViaEmail,
}) => {
  return (
    <div>
      <H4>General</H4>
      <HorizontalSpacer spacing={1} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ToggleButton
          active={notificationsEnabled}
          onToggle={() => onChangeNotificationsEnabled?.(!notificationsEnabled)}
        />
        <Spacer spacing={1} />
        <H3>Receive notifications</H3>
      </div>

      <HorizontalSpacer spacing={3} />
      <H4>Notify me through</H4>
      <HorizontalSpacer spacing={1} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <Checkbox checked={notifyViaEmail} onChange={() => onChangeNotifyViaEmail?.(!notifyViaEmail)} />
        <Spacer spacing={1} />
        <div style={{ maxWidth: "90%", overflowWrap: "break-word" }}>
          <H3>Email {userEmail && `(${userEmail})`}</H3>
        </div>
      </div>
      <HorizontalSpacer spacing={3} />
    </div>
  )
}

export default NotificationSettingsSection
